// @flow strict

// Action types
export const SET_GOOGLE_AUTH_TOKEN = 'SET_GOOGLE_AUTH_TOKEN';
export const SET_MICROSOFT_AUTH_TOKEN = 'SET_MICROSOFT_AUTH_TOKEN';
export const CLEAR_CALENDAR_AUTH = 'CLEAR_CALENDAR_AUTH';

// Type for Google auth token
export type GoogleAuthToken = {
  access_token: string,
  expires_in: number,
  issued_at: string,
  scope: string,
  token_type: string,
};

// Type for Microsoft auth token
export type MicrosoftAuthToken = {
  accessToken: string,
  account: mixed,
  expiresOn: Date,
  idToken: string,
  scopes: Array<string>,
  homeAccountId: string,
};

// Action types
export type SetGoogleAuthTokenAction = {
  type: typeof SET_GOOGLE_AUTH_TOKEN,
  payload: GoogleAuthToken,
};

export type SetMicrosoftAuthTokenAction = {
  type: typeof SET_MICROSOFT_AUTH_TOKEN,
  payload: MicrosoftAuthToken,
};

export type ClearCalendarAuthAction = {
  type: typeof CLEAR_CALENDAR_AUTH,
};

export type CalendarAuthAction =
  | SetGoogleAuthTokenAction
  | SetMicrosoftAuthTokenAction
  | ClearCalendarAuthAction;

/**
 * Action to set Google authentication token
 */
export const setGoogleAuthToken = (
  token: GoogleAuthToken,
): SetGoogleAuthTokenAction => ({
  type: SET_GOOGLE_AUTH_TOKEN,
  payload: token,
});

/**
 * Action to set Microsoft authentication token
 */
export const setMicrosoftAuthToken = (
  token: MicrosoftAuthToken,
): SetMicrosoftAuthTokenAction => ({
  type: SET_MICROSOFT_AUTH_TOKEN,
  payload: token,
});

/**
 * Action to clear all calendar authentication data
 */
export const clearCalendarAuth = (): ClearCalendarAuthAction => ({
  type: CLEAR_CALENDAR_AUTH,
});
